export interface ColumnItem {
  id: string;
  title: string;
  category: string;
  minutes: string;
  views: string;
  cover: string;
  badge: string;
  excerpt: string;
}

export const columns: ColumnItem[] = [
  {
    id: "c01",
    title: "这一届综艺为何频频靠“名场面”出圈？",
    category: "深度吃瓜",
    minutes: "18:24",
    views: "73.2万",
    cover: "https://readdy.ai/api/search-image?query=talk%20show%20studio%20with%20warm%20editorial%20magazine%20cover%20style%2C%20vibrant%20coral%20and%20amber%20background%2C%20abstract%20stage%20shapes%2C%20cinematic%20portrait%20composition%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=720&height=900&seq=col-01&orientation=portrait",
    badge: "专题解读",
    excerpt: "从剪辑节奏、嘉宾化学反应到话题运营，拆解名场面批量出现的底层逻辑。",
  },
  {
    id: "c02",
    title: "红毯造型背后的审美经济学",
    category: "深度吃瓜",
    minutes: "22:10",
    views: "56.8万",
    cover: "https://readdy.ai/api/search-image?query=glamorous%20evening%20gown%20on%20mannequin%20with%20warm%20red%20carpet%20lighting%2C%20fashion%20editorial%20photography%2C%20coral%20and%20gold%20tones%2C%20soft%20studio%20glow%2C%20portrait%20composition%2C%20high%20detail&width=720&height=900&seq=col-02&orientation=portrait",
    badge: "专题解读",
    excerpt: "一套造型如何撬动全网热度？从品牌选择到出片时机，解析红毯的流量密码。",
  },
  {
    id: "c03",
    title: "片场之外：一部剧的幕后“隐形剧组”",
    category: "深度吃瓜",
    minutes: "27:36",
    views: "42.5万",
    cover: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20crew%20with%20lighting%20and%20camera%20equipment%20on%20film%20set%2C%20warm%20practical%20lights%2C%20documentary%20photography%2C%20amber%20and%20deep%20brown%20tones%2C%20portrait%20composition%2C%20high%20detail&width=720&height=900&seq=col-03&orientation=portrait",
    badge: "幕后揭秘",
    excerpt: "灯光、美术、场记、统筹……镜头看不见的地方，是一支怎样的团队在运转。",
  },
];